import { ArrowPathIcon, BoltIcon, LockClosedIcon, UserIcon } from "@heroicons/react/24/outline";

const benefits = [
  {
    title: "Higher Availability",
    body: "Priority access to our servers ensures your interactions run without waiting in queue.",
    icon: BoltIcon,
  },
  {
    title: "Journeys after they log in",
    body: "Add a test account and we'll walk key product journeys, not just public pages.",
    icon: UserIcon,
  },
  {
    title: "Data Privacy",
    body: "Your data is not used to train AI models, ensuring complete confidentiality of your website content.",
    icon: LockClosedIcon,
  },
  {
    title: "Weekly UX monitoring",
    body: "Keep monitored pages and journeys fresh with an automated UX check about every week, so new usability issues surface before they affect customers.",
    icon: ArrowPathIcon,
  },
];

export default function BenefitsExplanation() {
  return (
    <section className="card">
      <div className="card-body">
        <h2 className="mb-0.5 text-lg font-semibold">Premium Benefits</h2>
        <span className="mb-5 block text-sm text-gray-500">For all paid plans</span>

        <div className="space-y-6">
          {benefits.map(({ title, body, icon: Icon }) => (
            <div key={title} className="flex items-start">
              <div className="mr-4 rounded-lg bg-primary-50 p-2">
                <Icon className="h-6 w-6 text-primary" aria-hidden="true" />
              </div>
              <div>
                <h3 className="mb-1 font-semibold">{title}</h3>
                <p className="text-sm text-gray-600">{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
